import React from "react";
import {
  TimeDateBar,
  StyledTimeClock,
  HebrewDateText,
  StyledH5,
  WeatherCenter,
} from "../../assets/wrappers/PublicStyle";

import Weather from "../../components/WeatherComponent";

const HeaderDisplay = ({
  currentTime,
  dayOfWeek,
  weather,
  address,
  theme,
  video,
  fontSize = "1.5rem",
}) => (
  <TimeDateBar fontFamily={theme.fontFamily}>
    <StyledTimeClock
      textColor={theme.clockTextColor}
      fontFamily={theme.fontFamily}
    >
      {currentTime.toTimeString().substring(0, 5)}
      <div className="timeDate">
        {currentTime.toLocaleDateString("he-IL")} &nbsp;&nbsp;{dayOfWeek}
        <WeatherCenter>
          {weather?.forecasts?.length > 0 && (
            <Weather
              forecasts={weather.forecasts}
              textColor={theme.clockTextColor}
              fontFamily={theme.fontFamily}
            />
          )}
        </WeatherCenter>
      </div>
    </StyledTimeClock>
    <StyledH5 fontSize={fontSize} textColor={theme.clockTextColor} fontFamily={theme.fontFamily}>
      {`ברוכים הבאים ל`} <strong>{address}</strong>
    </StyledH5>
    <HebrewDateText>
      <img
        src="https://res.cloudinary.com/dlhfcdscf/image/upload/v1748458707/public/logo_x95jav.png"
        height="130px"
        style={{ marginBottom: "-30px", marginLeft: "0px" }}
      />
    </HebrewDateText>
  </TimeDateBar>
);

export default HeaderDisplay;
